// removed by extract-text-webpack-plugin
module.exports = {"selfExport":"_5Xkk5BIaoBUyNa7QU5GBo_0","card_title":"_1hh24rFp6-v11sVYyYrxEC_0"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"sourceMap":true,"localIdentName":"[hash:base64]_0","importLoaders":true,"modules":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-afa69c6c","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/SelfExport/SelfExport.vue
// module id = qJx9
// module chunks = 29